import React, { useEffect, useState } from "react";
import { ScrollText } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, EmptyState, Loader } from "@/components/dashboard/ui";

export default function AdminAudit() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/audit").then(({ data }) => setLogs(data || [])).catch(() => setLogs([])); }, []);
  if (logs === null) return <Loader />;
  return (
    <div>
      <PageHeader title="Journal d'audit" subtitle="Historique des actions importantes." />
      {logs.length === 0 ? <EmptyState icon={ScrollText} title="Aucune entrée" /> : (
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <table className="w-full text-sm text-left">
            <thead className="bg-slate-50 text-xs font-semibold text-slate-500 uppercase tracking-wider">
              <tr><th className="px-4 py-3">Date</th><th className="px-4 py-3">Acteur</th><th className="px-4 py-3">Action</th><th className="px-4 py-3">Entité</th></tr>
            </thead>
            <tbody>{logs.map((l) => (
              <tr key={l.log_id} className="border-t border-slate-100" data-testid={`audit-${l.log_id}`}>
                <td className="px-4 py-2.5 text-slate-500">{new Date(l.created_at).toLocaleString("fr-CH")}</td>
                <td className="px-4 py-2.5 text-slate-800">{l.actor_name}</td>
                <td className="px-4 py-2.5"><span className="px-2 py-0.5 rounded-full bg-slate-100 text-xs font-medium">{l.action}</span></td>
                <td className="px-4 py-2.5 text-slate-500">{l.entity}</td>
              </tr>))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
